// Helpers for reading the /api/catalog/structure payload shape. The structure
// carries counts and standard codes only — questions are fetched per skill
// when a practice session starts.

export function findState(catalog, stateName) {
  if (!catalog) return null;
  return (catalog.states || []).find((state) => state.name === stateName) || null;
}

export function findGradeLevel(catalog, stateName, gradeName) {
  const state = findState(catalog, stateName);
  if (!state) return null;
  return (state.gradeLevels || []).find((gl) => gl.name === gradeName) || null;
}

// Major topics are the unit of the learning path. Grades without major topics
// fall back to a single bucket holding every topic.
export function getMajorTopics(gradeLevel) {
  if (!gradeLevel) return [];
  if ((gradeLevel.majorTopics || []).length) {
    return gradeLevel.majorTopics;
  }
  return [
    {
      name: 'Topics',
      questionCount: (gradeLevel.topics || []).reduce(
        (sum, topic) => sum + (topic.questionCount || 0),
        0
      ),
      subTopics: gradeLevel.topics || [],
    },
  ];
}

// A sub-topic without standards still practises as one skill, selected by name.
export function getGoalSections(subTopic) {
  if ((subTopic.goalSections || []).length) {
    return subTopic.goalSections;
  }
  return [{
    name: subTopic.name,
    code: '',
    marker: '',
    questionCount: subTopic.questionCount || 0,
  }];
}

// Every goal section under a major topic, flattened into practisable skills.
export function getSkills(majorTopic) {
  return (majorTopic.subTopics || []).flatMap((subTopic, index) =>
    getGoalSections(subTopic).map((goalSection) => ({
      ...goalSection,
      subTopicName: subTopic.name,
      subTopicNumber: index + 1,
    }))
  );
}

export function formatGoalMarker(subTopicNumber, goalSection) {
  const goalNumber = goalSection.goalNumber || goalSection.marker;
  if (!goalNumber) return '';
  const subgoalCode = goalSection.subgoalCode || '';
  return `${subTopicNumber}.${goalNumber}${subgoalCode ? `.${subgoalCode}` : ''}`;
}
